/**
 * Subdominio (primer segmento de window.location.hostname)
 * -> nombre del módulo en SystemModule / respuesta de /api/modules/active.
 *
 * Los overlays planos deben existir en:
 *   modules/<carpeta_del_modulo>/locales/domain/es.js
 *   modules/<carpeta_del_modulo>/locales/domain/en.js
 *
 * Añadir una fila aquí cuando un módulo nuevo publique traducciones por subdominio.
 */
export const SUBDOMAIN_TO_MODULE_FOR_DOMAIN_LOCALES = {
  fob: "fobtrading_module",
};
